import { ISelectOption } from 'src/components/ToggleSelect';
import { ICustomersFilters } from 'src/reducers/filtersReducer';
import { IWallet, WalletPlatform, WalletStatus } from '../wallets/types';
export const getFiltersCount = (customersFilters: ICustomersFilters) => {
  const objectKeys = Object.keys(customersFilters);
  return Object.values(customersFilters).reduce<number>((count, filterValue, currentIndex) => {
    const filterKey = objectKeys[currentIndex];
    const notToggleSelect =
      filterKey === 'conversionAgents' ||
      filterKey === 'sources' ||
      filterKey === 'retentionAgents' ||
      filterKey === 'referrers';
    if (
      (filterValue && !Array.isArray(filterValue)) ||
      (Array.isArray(filterValue) && filterValue.length > 0 && !notToggleSelect)
    ) {
      return count + 1;
    }
    switch (filterKey) {
      case 'sources': {
        const foundEnabledSources = customersFilters.sources.find((option: ISelectOption) => option.enabled);
        if (foundEnabledSources) {
          return count + 1;
        }
        break;
      }

      case 'conversionAgents': {
        const foundEnabledConversionAgents = customersFilters.conversionAgents.find(
          (option: ISelectOption) => option.enabled
        );
        if (foundEnabledConversionAgents) {
          return count + 1;
        }
        break;
      }

      case 'retentionAgents': {
        const foundEnabledRetentionAgents = customersFilters.retentionAgents.find(
          (option: ISelectOption) => option.enabled
        );
        if (foundEnabledRetentionAgents) {
          return count + 1;
        }
        break;
      }

      case 'referrers': {
        const foundEnabledReferrers = customersFilters.referrers.find((option: ISelectOption) => option.enabled);
        if (foundEnabledReferrers) {
          return count + 1;
        }
        break;
      }

      case 'ftdDateRange': {
        if (customersFilters.ftdDateRange?.startDate && customersFilters.ftdDateRange?.endDate) {
          return count + 1;
        }
        break;
      }

      default:
        // Handle default case if needed
        break;
    }

    return count;
  }, 0);
};

/**
 * MT5 accounts are excluded: both sides of a transfer are moved through the Wintrado gateway,
 * which has no account for an MT5 login, so the backend rejects any transfer touching one
 * (`createWalletTransfer` in wallets/userWallets.service.ts). MT5 wallets appear in this list
 * since they were un-filtered from the admin wallet list, so without this they would be offered —
 * and could even be preselected — as a transfer that can only ever fail.
 */
export const isWalletAllowedToTransfer = (w: IWallet) =>
  w.status === WalletStatus.Active && !w.isDemo && w.platform !== WalletPlatform.MT5;
